<div class="container">
    <div class="text-center">
    <h1>Thank You</h1>
    <h2>Thank you for your email, we will get back to you soon.</h2>
</div>
</div>
